<template>
    <div v-if="feeds.length" class="socialfeed">
        <div class="socialfeed-wrapper">
            <div class="socialfeed_grid__row">
                <header class="socialfeed-headline">
                    <h2 class="blue ce-headline-center">
                        {{ $t("newsfeed") }}
                    </h2>
                </header>
            </div>
            <swiper
                v-if="showSwiper"
                :modules="modules"
                :slides-per-view="1.2"
                :space-between="10"
                :speed="700"
                :breakpoints="{
                  '768': {
                    slidesPerView: 2.4
                  },
                }"
                :pagination="{
                    type: 'bullets',
                    clickable: 'true',
                }"
                :autoplay="false"
                :loop="false"
                :enabled="true"
                @slideChange="slideChange"
            >
                <swiper-slide v-for="feed in feeds">
                    <news-feed-item :feed="feed"></news-feed-item>
                </swiper-slide>
            </swiper>
            <div v-else class="socialfeed_grid__row is-grid">
                <news-feed-item v-for="feed in feeds" :feed="feed"></news-feed-item>
            </div>
        </div>
    </div>
</template>

<script>
import {computed, ref} from "vue";

import NewsfeedItem from "./NewsfeedItem";
import { Autoplay, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import {breakpointState} from "@/utils";

export default {
    name: "news-feed",
    components:{
        'news-feed-item': NewsfeedItem,
        Swiper,
        SwiperSlide
    },
    setup() {
        const feeds = ref([]);

        const getFeeds = () => {
            fetch("https://api.flockler.com/v1/sites/5553/articles")
                .then(r => r.json())
                .then(r => {
                    let f = [];
                    let s = r.articles.length;
                    s = s<=4?s:4;
                    for (let x=0; x < s;x++) {
                        let a = r.articles[x];

                        let feedLink = null;
                        let feedType = null;
                        let feedIcon = null;
                        let feedContent = "";
                        let feedImage = null;
                        let feedCreateTimestamp = 0;
                        let feedActionBar = [];

                        switch (a.type) {
                            case 'facebook_post':
                                feedLink = 'https://www.facebook.com/' + a.attachments.facebook_post.post_id_str;
                                feedType = 'facebook_post';
                                feedIcon = 'fa-facebook';
                                feedContent = a.attachments.facebook_post.message;
                                feedCreateTimestamp = new Date(a.attachments.facebook_post.created_time);
                                feedImage = a.attachments.facebook_post.picture ?? '';
                                feedActionBar.push({
                                    type: 'link',
                                    icon: 'fa-thumbs-up',
                                    src: 'https://www.facebook.com/' + a.attachments.facebook_post.post_id_str
                                });
                                feedActionBar.push({
                                    type: 'share',
                                    icon: 'fa-share',
                                    src:  'https://www.facebook.com/sharer.php?u=' + a.attachments.facebook_post.link
                                });
                                break;

                            case 'tweet':
                                feedLink = 'https://twitter.com/intent/retweet?tweet_id=' + a.attachments.tweet.tweet_id_str;
                                feedType = 'twitter_post';
                                feedIcon = 'fa-x-twitter'
                                feedContent = a.attachments.tweet.text;
                                feedCreateTimestamp = new Date(a.attachments.tweet.created_at);
                                feedImage = a.attachments.tweet.image_url ?? '';
                                feedActionBar.push({
                                    type: 'retweet',
                                    icon: 'fa-retweet',
                                    src: 'https://twitter.com/intent/retweet?tweet_id=' + a.attachments.tweet.tweet_id_str
                                });
                                feedActionBar.push({
                                    type: 'like',
                                    icon: 'fa-thumbs-up',
                                    src: 'https://twitter.com/intent/retweet?tweet_id=' + a.attachments.tweet.tweet_id_str
                                });
                                break;

                            case 'instagram':
                                feedLink = a.url;
                                feedType = 'instagram';
                                feedIcon = 'fa-instagram';
                                feedContent = a.attachments.instagram_item.caption;
                                feedCreateTimestamp = new Date(a.published_at);
                                feedImage = a.cover_url ?? '';


                                feedActionBar.push({
                                    type: 'link',
                                    icon: 'fa-link',
                                    src: a.url
                                });
                                break;

                            case 'linkedin':
                                 s++;
                                 continue;
                              /*  feedLink = a.attachments.linkedin_api.original_url;
                                feedType = 'linkedin_post';
                                feedIcon = 'fa-linkedin'
                                feedContent = a.attachments.linkedin_api.post.message;
                                feedCreateTimestamp = new Date(a.published_at);
                                feedImage = a.attachments.linkedin_api.post.images[0].image_url ?? '';
                                feedActionBar.push({
                                    type: 'share',
                                    icon: 'fa-share',
                                    src: a.attachments.linkedin_api.original_url
                                });*/
                                break;

                        }

                        f.push({
                            feed_link: feedLink,
                            feed_type: feedType,
                            feed_icon: feedIcon,
                            feed_content: feedContent,
                            feed_image: feedImage,
                            feed_create_ts: feedCreateTimestamp,
                            feed_action_bar: feedActionBar
                        });
                    }
                    feeds.value = f;
                });
        }

        getFeeds();

        /*
        if (usercentrics) {
            let service  = usercentrics.getConsents().find(c=>{
                return c.templateId === "uJyv6-Nm";
            })
            if (service && service.consentStatus) {
                getFeeds();
            }
        }

        const checkConsense = function () {
            if (usercentrics) {
                let service  = usercentrics.getConsents().find(c=>{
                    return c.templateId === "uJyv6-Nm";
                })
                if (service && service.consentStatus) {
                    if (!feeds.value.length) {
                        getFeeds();
                    }
                } else {
                    feeds.value = [];
                }
            }
        }

        checkConsense();

        window.addEventListener('ucdatachange', (e) => {
            checkConsense();
        });

         */

        const showSwiper =  computed(() => {
            return breakpointState.value.up.indexOf('tablet_portrait') !== -1;
        });

        const slideChange = (swiper) => {
            if (swiper.isEnd) {
                swiper.wrapperEl.classList.add('is-end');
            } else {
                swiper.wrapperEl.classList.remove('is-end');
            }
        }

        return {
            feeds,
            modules: [Autoplay, Pagination],
            showSwiper,
            slideChange
        };
    }
}
</script>

<style lang="scss">
@use "@/scss/design-library/variables";
@use "@/scss/design-library/grid";
@use "@/scss/design-library/colors";
@use "@/scss/design-library/typography";
@use "@/scss/design-library/functions/calculate";

.socialfeed {
    --mdc-layout-grid-margin-mobile: 0;
    --mdc-layout-grid-margin-tablet_portrait: 0;

    .socialfeed_grid__row {
        @include grid.inner();
    }

    .socialfeed-headline {
        @include grid.cell-span_(12);
        justify-content: center;
        margin-bottom: calculate.rem(20);
    }
    .swiper-wrapper {
        transition: all 1s;
        margin-left: 8vw;
        &.is-end {
            margin-left: -8vw;
        }
    }
}
.is-grid {
    .socialfeed-item {
        @include grid.cell-span_(3);
    }
}
.socialfeed-item {

    &:nth-child(4) {
        @include grid.media-query_(tablet_landscape) {
            display: none;
        }
    }
    .socialfeed-item__image {
        display: block;
        text-decoration: none;
        margin-bottom: calculate.rem(25);
        img {
            aspect-ratio: 1;
            object-fit: cover;
            object-position: top;
            max-width: 100%;
            height: auto;
            border-radius: #{variables.$default-border-radius};
        }
    }
    .socialfeed-item__content {
        display: flex;
        justify-content: flex-start;
    }
    .socialfeed-item__icon {
        font-size: calculate.rem(31);
        padding-right: calculate.rem(12);

        .fa-brands {
            color: #257CE1;
        }
    }
    .socialfeed-item__text p{
        @include typography.c1();

    }

    .socialfeed-item__info {
        @include typography.c3();
        display: flex;
        align-self: flex-end;
        justify-content: space-between;
        align-items: center;
        .socialfeed-item__action {
            justify-self: end;
        }
    }

    .socialfeed-item__created {
        padding: calculate.rem(12) calculate.rem(5) calculate.rem(12) 0;
    }

    .socialfeed-item__actionicon {
        a {
            display: inline-block;
            padding: calculate.rem(12) calculate.rem(5);
            color: colors.$black;
        }
    }
}
</style>
